webpackJsonp([1],Array(36).concat([
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Footer_vue__ = __webpack_require__(64);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    FooterView: __WEBPACK_IMPORTED_MODULE_0__components_Footer_vue__["a" /* default */]
  },
  name: 'app'
});

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  // TODO ダミーなので後で消す
  data: function data() {
    return {
      path: 'aa'
    };
  },

  methods: {
    go: function go(pathName) {
      this.$router.push({ name: pathName });
    }
  }
});

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(9);

//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Login',
  data: function data() {
    return {
      isProgress: true
    };
  },
  created: function created() {
    this.checkParameter();
    this.checkLogin();
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    loginImgNum: function loginImgNum() {
      var items = ['u-pin', 'u-so', 'u-man'];
      // 最大値は配列の「要素数」にする
      var random = Math.floor(Math.random() * items.length);
      return random;
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])('UserInfo', {
    shareScoreID: 'getShareScoreID',
    myUID: 'getMyUID'
  })),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('ScoreTable', {
    setScoreIDToUserDB: 'setScoreIDToUserDB'
  }), Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["d" /* mapMutations */])('UserInfo', {
    setShareScoreID: 'setShareScoreID',
    setMyUID: 'setMyUID'
  }), Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])('UserInfo', {
    getShareScoreID: 'getShareScoreID'
  }), {
    checkParameter: function checkParameter() {
      var scoreID = this.$route.query.share_score_id;
      if (!scoreID) {
        return;
      }
      this.setShareScoreID(scoreID);
    },
    checkLogin: function checkLogin() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.auth().onAuthStateChanged(function (user) {
        if (user) {
          // ログイン済みの場合はScoreへ飛ばす
          _this.setMyUID(user.uid);
          _this.goScorePage();
        }
        _this.isProgress = false;
      });
    },
    signupByAnonymous: function signupByAnonymous() {
      this.isProgress = true;
      __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.auth().signInAnonymously().catch(function (error) {
        console.log(error.code);
        console.log(error.message);
        alert('匿名ログインに失敗しました');
        this.isProgress = false;
      });
    },
    signup: function signup() {
      var _this2 = this;

      this.isProgress = true;
      var provider = new __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.auth.GoogleAuthProvider();
      __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.auth().signInWithPopup(provider).then(function (result) {
        _this2.setUserInfo(result);
        _this2.goScorePage();
      }, function (error) {
        alert('ログインに失敗しました');
        console.log(error);
        _this2.isProgress = false;
      });
    },
    goScorePage: function goScorePage() {
      if (this.shareScoreID) {
        var sID = this.shareScoreID;
        this.setScoreIDToUserDB({ scoreID: sID, uid: this.myUID, timestamp: __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.firestore.FieldValue.serverTimestamp() });
        this.$router.push({ name: 'Score', params: { id: sID } });
        return;
      }
      this.$router.push({ name: 'NewScore' });
    },
    setUserInfo: function setUserInfo(result) {
      var db = __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.firestore();
      db.collection('Users').doc(result.user.uid).set({
        name: result.user.displayName
      });
    }
  })
});

/***/ }),
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(9);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MyPage',
  mounted: function mounted() {
    this.isProgress = true;
    this.checkLogin();
  },
  data: function data() {
    return {
      myScores: [],
      isProgress: true,
      checks: []
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])('UserInfo', {
    myUID: 'getMyUID'
  })),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["d" /* mapMutations */])('UserInfo', {
    setMyUID: 'setMyUID'
  }), {
    checkLogin: function checkLogin() {
      var _this = this;

      var db = __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.firestore();
      var settings = { timestampsInSnapshots: true };
      db.settings(settings);
      __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.auth().onAuthStateChanged(function (user) {
        if (user) {
          // User is signed in.
          _this.getScoreIDFromScoreHistory(user.uid);
          _this.setMyUID(user.uid);
        } else {
          // No user is signed in.
          _this.goLoginPage();
        }
      });
    },
    goLoginPage: function goLoginPage() {
      this.$router.push({ name: 'Login' });
    },
    getScoreIDFromScoreHistory: function getScoreIDFromScoreHistory(uid) {
      var _this2 = this;

      var db = __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.firestore();
      db.collection('Users').doc(uid).collection('ScoreHistory').orderBy('timestamp', 'desc').get().then(function (querySnapshot) {
        querySnapshot.forEach(function (doc) {
          // doc.data() is never undefined for query doc snapshots
          if (doc.exists) {
            var targetDate = _this2.changeToDateFromTimeStamp(doc.data().timestamp.seconds);
            var targetData = doc.data();
            targetData.targetDate = targetDate;
            targetData.ID = doc.data().scoreID;
            _this2.myScores.push(targetData);
          }
          _this2.isProgress = false;
        });
      });
    },
    changeToDateFromTimeStamp: function changeToDateFromTimeStamp(intTime) {
      var d = new Date(intTime * 1000);
      var year = d.getFullYear();
      var month = d.getMonth() + 1;
      var day = d.getDate();
      var hour = ('0' + d.getHours()).slice(-2);
      var min = ('0' + d.getMinutes()).slice(-2);
      var sec = ('0' + d.getSeconds()).slice(-2);

      return year + '-' + month + '-' + day + ' ' + hour + ':' + min + ':' + sec;
    },
    signOut: function signOut() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.auth().signOut().then(function (_) {
        _this3.goLoginPage();
      });
    },
    combineMemberName: function combineMemberName(member) {
      var res = '';
      for (var key in member) {
        res += ' ' + member[key].name;
      }
      return res;
    },
    deleteScore: function deleteScore() {
      var _this4 = this;

      var _loop = function _loop(key) {
        _this4.myScores.some(function (v, i) {
          if (v.ID === _this4.checks[key]) _this4.myScores.splice(i, 1);
        });
        var db = __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.firestore();
        db.collection('Users').doc(_this4.myUID).collection('ScoreHistory').doc(_this4.checks[key]).delete();
      };

      for (var key in this.checks) {
        _loop(key);
      }
      this.checks = [];
    }
  })
});

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TheScoreSlider_vue__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TheScoreTable_vue__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(9);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    TheScoreSlider: __WEBPACK_IMPORTED_MODULE_4__TheScoreSlider_vue__["a" /* default */],
    TheScoreTable: __WEBPACK_IMPORTED_MODULE_5__TheScoreTable_vue__["a" /* default */]
  },
  created: function created() {
    this.changeLoading(true);
    this.checkLogin();
    this.checkParameter();
  },
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    // ルート変更に反応する...
    // parameter の変更に反応する
    this.changeLoading(true);
    this.checkLogin();
    this.checkParameter();
    next();
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapGetters */])('UserInfo', {
    myScoreID: 'getMyScoreID',
    myUID: 'getMyUID',
    myDisplayName: 'getMyDisplayName'
  }), Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapGetters */])('ScoreTable', {
    tableData: 'getTableData',
    columns: 'getColumns',
    loading: 'getLoading',
    currentPageNum: 'getCurrentPageNum'
  }), {
    // total point
    totalPoints: function totalPoints() {
      var result = [{}];
      for (var arrayIndex in this.tableData) {
        for (var key in this.tableData[arrayIndex]) {
          if (key === '__index') {
            continue;
          }
          if (result[0][key] === undefined) {
            result[0][key] = this.tableData[arrayIndex][key];
            continue;
          }
          result[0][key] += this.tableData[arrayIndex][key];
        }
      }
      return result;
    },

    isSanma: {
      get: function get() {
        return this.getIsSanma();
      },
      set: function set(value) {
        if (value) {
          this.toSanma();
          this.sliderToSanma();
        } else {
          this.toYonma();
          this.sliderToYonma();
        }
        this.changeIsSanma(value);
      }
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapGetters */])('ScoreTable', {
    getIsSanma: 'getIsSanma'
  }), Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["d" /* mapMutations */])('ScoreTable', {
    changeLoading: 'changeLoading',
    setColumnLabel: 'setColumnLabel',
    setColumnUID: 'setColumnUID',
    addScoreRow: 'addScoreRow',
    changeIsSanma: 'changeIsSanma',
    toSanma: 'toSanma',
    toYonma: 'toYonma',
    changeCurrentPageNum: 'changeCurrentPageNum'
  }), Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["d" /* mapMutations */])('UserInfo', {
    setMyScoreID: 'setMyScoreID',
    setMyUID: 'setMyUID',
    setMyDisplayName: 'setMyDisplayName'
  }), Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["d" /* mapMutations */])('TheScoreSlider', {
    sliderToSanma: 'toSanma',
    sliderToYonma: 'toYonma'
  }), Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])('ScoreTable', {
    setDataFromScoreID: 'setDataFromScoreID',
    resetData: 'reset',
    makeNewScore: 'makeNewScoreDB',
    setMemberToUserDB: 'setScoreMemberToUserDB',
    updateDBScoreMember: 'updateDBScoreMember',
    updateScoreDB: 'updateScoreDB',
    updateScoreMemberOfUserDB: 'updateScoreMemberOfUserDB',
    unsubscribeListenData: 'unsubscribeListenData',
    listenDataFromScoreDB: 'listenDataFromScoreDB'
  }), {
    checkLogin: function checkLogin() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_3_firebase___default.a.auth().onAuthStateChanged(function (user) {
        if (!user) {
          // no Sign in
          _this.goLoginPage();
        } else {
          var displayName = user.displayName;
          if (user.isAnonymous) {
            displayName = 'A';
          }
          _this.setColumnLabel({ num: 0, val: displayName });
          _this.setColumnUID({ num: 0, val: user.uid });
          _this.setMyUID(user.uid);
          _this.setMyDisplayName(displayName);
        }
      });
    },
    checkParameter: function checkParameter() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var scoreID;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                scoreID = _this2.$route.params.id;

                if (scoreID) {
                  _context.next = 4;
                  break;
                }

                _this2.changeLoading(false);
                return _context.abrupt('return');

              case 4:
                _this2.setMyScoreID(scoreID);
                _context.next = 7;
                return _this2.setDataFromScoreID(scoreID);

              case 7:
                _this2.changeLoading(false);

              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    goLoginPage: function goLoginPage() {
      this.$router.push({ name: 'Login' });
    },

    addRow: function addRow() {
      this.addScoreRow();
      this.addScoreToFireStore();
    },
    // auto input last data
    addScoreToFireStore: function addScoreToFireStore() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var now, scoreID;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                now = __WEBPACK_IMPORTED_MODULE_3_firebase___default.a.firestore.FieldValue.serverTimestamp();

                if (!(_this3.myScoreID === '')) {
                  _context2.next = 11;
                  break;
                }

                _context2.next = 4;
                return _this3.makeNewScore({ tableData: _this3.tableData, timestamp: now });

              case 4:
                scoreID = _context2.sent;

                _this3.setMyScoreID(scoreID);
                _this3.setMemberToUserDB({ scoreID: scoreID, uid: _this3.myUID, timestamp: now });
                _this3.updateDBScoreMember({ scoreID: scoreID });
                _this3.listenDataFromScoreDB(scoreID);
                _context2.next = 14;
                break;

              case 11:
                _this3.updateScoreDB({ scoreID: _this3.myScoreID, tableData: _this3.tableData, timestamp: now });
                _this3.updateScoreMemberOfUserDB({ uid: _this3.myUID, scoreID: _this3.myScoreID, timestamp: now });
                _this3.updateDBScoreMember({ scoreID: _this3.myScoreID });

              case 14:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    newScorePage: function newScorePage() {
      this.changeLoading(true);
      this.resetData();
      this.setMyScoreID('');
      this.checkLogin();
      this.changeLoading(false);
    },
    share: function share() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var scoreID;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this4.changeLoading(true);

                if (!(_this4.myScoreID === '')) {
                  _context3.next = 11;
                  break;
                }

                _context3.next = 4;
                return _this4.makeNewScore({ tableData: _this4.tableData, timestamp: __WEBPACK_IMPORTED_MODULE_3_firebase___default.a.firestore.FieldValue.serverTimestamp() });

              case 4:
                scoreID = _context3.sent;

                _this4.setMyScoreID(scoreID);
                _this4.setMemberToUserDB({ scoreID: scoreID, uid: _this4.myUID, timestamp: __WEBPACK_IMPORTED_MODULE_3_firebase___default.a.firestore.FieldValue.serverTimestamp() });
                _this4.updateDBScoreMember({ scoreID: scoreID });
                _this4.listenDataFromScoreDB(scoreID);

                // makeNewScore関数を使うとその後のクリップボードへのcopy処理がうまくいかないためここで処理を終了
                _this4.changeLoading(false);
                return _context3.abrupt('return');

              case 11:
                _this4.copyToClipBoard();
                _this4.changeLoading(false);

              case 13:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this4);
      }))();
    },
    copyToClipBoard: function copyToClipBoard() {
      var ta = document.createElement('textArea');
      // Copy to clip board
      var shareUrl = 'https://' + window.location.hostname + '?share_score_id=' + this.myScoreID + '&' + 'openExternalBrowser=1';
      ta.value = shareUrl;
      document.body.appendChild(ta);

      // ios
      if (navigator.userAgent.match(/ipad|iphone/i)) {
        var range = document.createRange();
        range.selectNodeContents(ta);
        var selection = window.getSelection();
        selection.removeAllRanges();
        selection.addRange(range);
        ta.setSelectionRange(0, 999999);
      } else {
        ta.select();
      }
      document.execCommand('copy');
      ta.parentElement.removeChild(ta);

      alert('クリップボードに共有URL \n' + shareUrl + '\n をCOPYしました');
    }
  }),
  watch: {
    myScoreID: function myScoreID(newValue, oldValue) {
      if (oldValue === '') {
        return;
      }
      this.unsubscribeListenData();
    },
    tableData: function tableData() {
      var pageNum = this.tableData.length / 5;
      this.changeCurrentPageNum(Math.ceil(pageNum));
    }
  }
});

/***/ }),
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(9);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// mapActions
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapMutations */])('ScoreTable', {
    changeLastRow: 'changeLastRow',
    decrement: 'decrementLastRowCell',
    increment: 'incrementLastRowCell'
  }), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapMutations */])('TheScoreSlider', {
    toSanma: 'toSanma',
    toYonma: 'toYonma'
  }), {
    changeData: function changeData(val, player) {
      var changeObj = { val: val, player: player };
      this.changeLastRow(changeObj);
    },
    autoInputLastData: function autoInputLastData(inputPlayer) {
      var zeroCount = 0;
      var zeroPlayer = '';
      for (var key in this.tableLastRow) {
        if (key === '__index') {
          continue;
        }
        if (this.tableLastRow[key] === 0) {
          ++zeroCount;
          zeroPlayer = key;
        }
      }
      if (zeroCount === 1 && zeroPlayer !== inputPlayer) {
        // auto input
        var sum = 0;
        for (var _key in this.tableLastRow) {
          if (_key === '__index') {
            continue;
          }
          sum += this.tableLastRow[_key];
        }
        this.changeData(-sum, zeroPlayer);
        return;
      }

      if (zeroCount === 0) {
        this.changeTopData(inputPlayer);
      }
    },
    changeTopData: function changeTopData(inputPlayer) {
      var maxPoint = -99999;
      var maxPointPlayer = '';
      for (var key in this.tableLastRow) {
        if (key === '__index') {
          continue;
        }
        if (this.tableLastRow[key] > maxPoint) {
          maxPoint = this.tableLastRow[key];
          maxPointPlayer = key;
        }
      }
      // if it's myself do nothing
      if (maxPointPlayer === inputPlayer) {
        return;
      }

      // auto input
      var sum = 0;
      for (var _key2 in this.tableLastRow) {
        if (_key2 === maxPointPlayer || _key2 === '__index') {
          continue;
        }
        sum += this.tableLastRow[_key2];
      }
      this.changeData(-sum, maxPointPlayer);
    },

    plus: function plus(player) {
      this.increment({ player: player });
      this.autoInputLastData(player);
    },
    minus: function minus(player) {
      this.decrement({ player: player });
      this.autoInputLastData(player);
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('TheScoreSlider', {
    sliders: 'getSliders'
  }), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('ScoreTable', {
    tableData: 'getTableData',
    columns: 'getColumns',
    tableLastRow: 'getLastRow',
    tableLastRowVal: 'getLastRowPlayerVal',
    isSanma: 'getIsSanma'
  })),
  watch: {
    isSanma: function isSanma() {
      if (this.isSanma) {
        this.toSanma();
      } else {
        this.toYonma();
      }
    }
  }
});

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(9);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// mapActions
// changeCell
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      // As it is updated automatically by libraly, it is difined as local variable not in vuex
      paginationControl: { rowsPerPage: 5, page: 1 }
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    changeDataByKeyboard: function changeDataByKeyboard(index, val, player) {
      var updateVal = { targetIndex: index, val: val, player: player };
      this.changeCell(updateVal);
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapMutations */])('ScoreTable', {
    changeCell: 'changeCell'
  }), {
    removeFoucs: function removeFoucs() {
      document.activeElement.blur();
    },
    checkZeroSum: function checkZeroSum(row) {
      var sum = 0;
      for (var key in row) {
        if (key === '__index') {
          continue;
        }
        sum += row[key];
      }
      return sum !== 0;
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('ScoreTable', {
    columns: 'getColumns',
    tableData: 'getTableData',
    lastTableRow: 'getLastRow',
    currentPageNum: 'getCurrentPageNum',
    loading: 'getLoading'
  })),
  watch: {
    currentPageNum: function currentPageNum() {
      this.paginationControl.page = this.currentPageNum;
    }
  }
});

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_analytics__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_analytics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__fortawesome_fontawesome_free_css_fontawesome_css__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__fortawesome_fontawesome_free_css_fontawesome_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__fortawesome_fontawesome_free_css_fontawesome_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__fortawesome_fontawesome_free_css_brands_css__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__fortawesome_fontawesome_free_css_brands_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__fortawesome_fontawesome_free_css_brands_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__fortawesome_fontawesome_free_css_regular_css__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__fortawesome_fontawesome_free_css_regular_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__fortawesome_fontawesome_free_css_regular_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__fortawesome_fontawesome_free_css_solid_css__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__fortawesome_fontawesome_free_css_solid_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__fortawesome_fontawesome_free_css_solid_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_quasar_framework_dist_umd_quasar_mat_css__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_quasar_framework_dist_umd_quasar_mat_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_quasar_framework_dist_umd_quasar_mat_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_quasar_framework_dist_quasar_mat_esm__ = __webpack_require__(151);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.








// 使用するカテゴリーのファイルを import







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_10_quasar_framework_dist_quasar_mat_esm__["y" /* default */], { components: [__WEBPACK_IMPORTED_MODULE_10_quasar_framework_dist_quasar_mat_esm__["m" /* QLayout */], __WEBPACK_IMPORTED_MODULE_10_quasar_framework_dist_quasar_mat_esm__["g" /* QInput */], __WEBPACK_IMPORTED_MODULE_10_quasar_framework_dist_quasar_mat_esm__["a" /* QBtn */], __WEBPACK_IMPORTED_MODULE_10_quasar_framework_dist_quasar_mat_esm__["n" /* QLayoutFooter */], __WEBPACK_IMPORTED_MODULE_10_quasar_framework_dist_quasar_mat_esm__["w" /* QTabs */], __WEBPACK_IMPORTED_MODULE_10_quasar_framework_dist_quasar_mat_esm__["t" /* QTab */], __WEBPACK_IMPORTED_MODULE_10_quasar_framework_dist_quasar_mat_esm__["u" /* QTabPane */], __WEBPACK_IMPORTED_MODULE_10_quasar_framework_dist_quasar_mat_esm__["r" /* QRouteTab */], __WEBPACK_IMPORTED_MODULE_10_quasar_framework_dist_quasar_mat_esm__["v" /* QTable */], __WEBPACK_IMPORTED_MODULE_10_quasar_framework_dist_quasar_mat_esm__["s" /* QSlider */], __WEBPACK_IMPORTED_MODULE_10_quasar_framework_dist_quasar_mat_esm__["o" /* QList */], __WEBPACK_IMPORTED_MODULE_10_quasar_framework_dist_quasar_mat_esm__["p" /* QListHeader */], __WEBPACK_IMPORTED_MODULE_10_quasar_framework_dist_quasar_mat_esm__["h" /* QItem */], __WEBPACK_IMPORTED_MODULE_10_quasar_framework_dist_quasar_mat_esm__["i" /* QItemMain */], __WEBPACK_IMPORTED_MODULE_10_quasar_framework_dist_quasar_mat_esm__["j" /* QItemSeparator */], __WEBPACK_IMPORTED_MODULE_10_quasar_framework_dist_quasar_mat_esm__["k" /* QItemSide */], __WEBPACK_IMPORTED_MODULE_10_quasar_framework_dist_quasar_mat_esm__["l" /* QItemTile */], __WEBPACK_IMPORTED_MODULE_10_quasar_framework_dist_quasar_mat_esm__["d" /* QChipsInput */], __WEBPACK_IMPORTED_MODULE_10_quasar_framework_dist_quasar_mat_esm__["e" /* QFab */], __WEBPACK_IMPORTED_MODULE_10_quasar_framework_dist_quasar_mat_esm__["f" /* QFabAction */], __WEBPACK_IMPORTED_MODULE_10_quasar_framework_dist_quasar_mat_esm__["b" /* QBtnDropdown */], __WEBPACK_IMPORTED_MODULE_10_quasar_framework_dist_quasar_mat_esm__["q" /* QProgress */], __WEBPACK_IMPORTED_MODULE_10_quasar_framework_dist_quasar_mat_esm__["x" /* QTd */], __WEBPACK_IMPORTED_MODULE_10_quasar_framework_dist_quasar_mat_esm__["c" /* QCheckbox */]] });

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_analytics___default.a, {
  id: 'UA-128259425-1',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */]
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] },
  store: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */]
});

/***/ }),
/* 60 */,
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(36);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_061b33cc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(66);
function injectStyle (ssrContext) {
  __webpack_require__(62)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_061b33cc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 62 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 63 */,
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__ = __webpack_require__(37);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55187590_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__ = __webpack_require__(65);
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55187590_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fotter"},[_c('q-layout-footer',[(_vm.$route.name != 'Login')?_c('q-tabs',{key:'other-secondary',staticClass:"footer",attrs:{"inverted":"","color":'secondary',"align":"justify"}},[_c('q-tab',{attrs:{"slot":"title","icon":"","label":"Score"},on:{"click":function($event){_vm.go('Score')}},slot:"title"}),_vm._v(" "),_c('q-tab',{attrs:{"slot":"title","icon":"","label":"MyPage"},on:{"click":function($event){_vm.go('MyPage')}},slot:"title"})],1):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('q-layout',[_c('header',[_c('span',[_vm._v("MAHJONG SCORE MANAGEMENT")])]),_vm._v(" "),_c('main',[_c('router-view')],1),_vm._v(" "),_c('footer-view')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Login__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_MyPage__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ScorePage__ = __webpack_require__(98);



// import Score from '@/components/Score'



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/mypage',
    name: 'MyPage',
    component: __WEBPACK_IMPORTED_MODULE_3__components_MyPage__["a" /* default */]
  }, {
    path: '/score',
    name: 'NewScore',
    component: __WEBPACK_IMPORTED_MODULE_4__components_ScorePage__["a" /* default */]
  }, {
    path: '/score/:id',
    name: 'Score',
    component: __WEBPACK_IMPORTED_MODULE_4__components_ScorePage__["a" /* default */]
  }, {
    path: '*',
    name: 'Login',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Login__["a" /* default */]
  }]
}));

/***/ }),
/* 68 */,
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(38);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ed387a04_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(91);
function injectStyle (ssrContext) {
  __webpack_require__(70)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ed387a04"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ed387a04_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 70 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login"},[(_vm.isProgress)?_c('q-progress',{attrs:{"indeterminate":"","stripe":"","animate":"","color":"teal-2"}}):_vm._e(),_vm._v(" "),(_vm.loginImgNum == 0 )?_c('img',{attrs:{"src":__webpack_require__(92),"alt":"red-u-pin"}}):(_vm.loginImgNum == 1 )?_c('img',{attrs:{"src":__webpack_require__(93),"alt":"red-u-so"}}):_c('img',{attrs:{"src":__webpack_require__(94),"alt":"red-u-man"}}),_vm._v(" "),_c('div',{staticStyle:{"padding-bottom":"20px"}},[_c('q-btn',{staticClass:"login_btn",attrs:{"icon":"","color":"secondary","label":"Sign in by Google","disable":_vm.isProgress},on:{"click":function($event){_vm.signup()}}})],1),_vm._v(" "),_c('q-btn',{attrs:{"flat":"","dense":"","label":"Use without login","color":"primary"},on:{"click":_vm.signupByAnonymous}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/u-pin.cad2948.png";

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/u-so.f088a34.png";

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/u-man.91b18fe.png";

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MyPage_vue__ = __webpack_require__(46);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09a8effb_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyPage_vue__ = __webpack_require__(97);
function injectStyle (ssrContext) {
  __webpack_require__(96)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-09a8effb"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MyPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09a8effb_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 96 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mypage"},[_c('div',{staticClass:"btn-area"},[(_vm.checks.length !== 0)?_c('q-btn',{attrs:{"icon":"far fa-trash-alt","rounded":"","flat":"","color":"red","size":"25px","align":"center"},on:{"click":_vm.deleteScore}}):_vm._e(),_vm._v(" "),_c('q-btn',{attrs:{"icon":"fas fa-sign-out-alt","rounded":"","flat":"","size":"25px"},on:{"click":_vm.signOut}})],1),_vm._v(" "),_c('q-list',{staticStyle:{"padding-bottom":"100px"},attrs:{"highlight":"","link":"","separator":""}},[(_vm.isProgress)?_c('q-progress',{attrs:{"indeterminate":"","stripe":"","animate":"","color":"teal-2"}}):_vm._e(),_vm._v(" "),_c('q-list-header',[_vm._v("History")]),_vm._v(" "),_vm._l((_vm.myScores),function(score,index){return _c('q-item',{key:score.ID,staticStyle:{"padding-left":"10px"},attrs:{"to":{ name: 'Score', params:{ id: score.ID }}}},[_c('q-checkbox',{key:score.ID,attrs:{"val":score.ID,"color":"red","checked-icon":"far fa-check-circle","unchecked-icon":"far fa-circle","indeterminate-icon":"far fa-circle"},model:{value:(_vm.checks),callback:function ($$v) {_vm.checks=$$v},expression:"checks"}}),_vm._v(" "),_c('q-item-main',{staticStyle:{"margin-left":"10px"},attrs:{"label":_vm.combineMemberName(score.member)}}),_vm._v(" "),_c('q-item-side',{attrs:{"right":"","stamp":score.targetDate}})],1)})],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ScorePage_vue__ = __webpack_require__(47);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17a00f6e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ScorePage_vue__ = __webpack_require__(136);
function injectStyle (ssrContext) {
  __webpack_require__(99)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ScorePage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17a00f6e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ScorePage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 99 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TheScoreSlider_vue__ = __webpack_require__(57);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32fbda20_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TheScoreSlider_vue__ = __webpack_require__(132);
function injectStyle (ssrContext) {
  __webpack_require__(131)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TheScoreSlider_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32fbda20_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TheScoreSlider_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 131 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-list',_vm._l((_vm.sliders),function(slider,index){return _c('q-item',{key:slider.player},[_c('span',{staticClass:"slider_back_name",class:slider.color},[_vm._v(_vm._s(_vm.columns[index].label))]),_vm._v(" "),_c('q-btn',{staticStyle:{"padding-top":"0","padding-bottom":"0"},attrs:{"flat":"","size":"0.8rem","color":"deep-orange-3","repeat-timeout":100,"icon":"fas fa-minus-circle"},on:{"click":function($event){_vm.minus(slider.player)}}}),_vm._v(" "),_c('q-item-main',[_c('q-slider',{attrs:{"value":_vm.tableLastRowVal(slider.player),"min":-100,"max":50,"label":"","color":slider.color},on:{"change":function (val) { _vm.changeData(val, slider.player); _vm.autoInputLastData(slider.player) }}})],1),_vm._v(" "),_c('q-btn',{staticStyle:{"padding-top":"0","padding-bottom":"0"},attrs:{"flat":"","size":"0.8rem","color":"cyan-3","repeat-timeout":100,"icon":"fas fa-plus-circle"},on:{"click":function($event){_vm.plus(slider.player)}}})],1)}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TheScoreTable_vue__ = __webpack_require__(58);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_486703c6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TheScoreTable_vue__ = __webpack_require__(135);
function injectStyle (ssrContext) {
  __webpack_require__(134)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TheScoreTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_486703c6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TheScoreTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 134 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-table',{staticClass:"score_table",attrs:{"data":_vm.tableData,"columns":_vm.columns,"row-key":"name","color":"primary","loading":_vm.loading,"pagination":_vm.paginationControl},on:{"update:pagination":function($event){_vm.paginationControl=$event}},scopedSlots:_vm._u([{key:"header",fn:function(props){return _c('tr',{},_vm._l((props.cols),function(col){return _c('th',{key:col.name,staticClass:"text-center"},[_c('q-input',{attrs:{"align":"center","hide-underline":""},model:{value:(col.label),callback:function ($$v) {_vm.$set(col, "label", $$v)},expression:"col.label"}})],1)}))}},_vm._l((_vm.columns),function(column){return {key:'body-cell-' + column.name,fn:function(props){return [_c('q-td',{class:[{ 'not-zero-sum': _vm.checkZeroSum(props.row) }]},[_c('q-input',{class:{ 'last-row': props.row === _vm.lastTableRow},attrs:{"align":"center","type":"number","hide-underline":"","value":props.value},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.removeFoucs($event)},"change":function (val) { _vm.changeDataByKeyboard(props.row.__index, val, column.name) }}})],1)]}}}),{key:"bottom",fn:function(props){return (props.pagesNumber > 1)?_c('div',{staticClass:"row flex-center q-py-sm",staticStyle:{"margin-left":"auto"}},[_c('q-btn',{staticClass:"q-mr-sm",attrs:{"round":"","dense":"","size":"sm","icon":"fas fa-angle-left","color":"cyan-2","disable":props.isFirstPage},on:{"click":props.prevPage}}),_vm._v(" "),_c('div',{staticClass:"q-mr-sm",staticStyle:{"font-size":"small"}},[_vm._v("\n      Page "+_vm._s(props.pagination.page)+" / "+_vm._s(props.pagesNumber)+"\n    ")]),_vm._v(" "),_c('q-btn',{attrs:{"round":"","dense":"","size":"sm","icon":"fas fa-angle-right","color":"cyan-2","disable":props.isLastPage},on:{"click":props.nextPage}})],1):_vm._e()}}])})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[_c('q-btn',{staticStyle:{"float":"left","margin":"-38px 0 3px 5px"},attrs:{"outline":"","disable":_vm.loading,"icon":"fas fa-share-alt","color":"secondary"},on:{"click":_vm.share}}),_vm._v(" "),_c('q-btn',{staticClass:"new_btnnw",staticStyle:{"float":"right","margin":"-38px 5px 3px 0"},attrs:{"outline":"","disable":_vm.loading,"color":"grey","label":"New"},on:{"click":_vm.newScorePage}}),_vm._v(" "),(_vm.tableData.length === 1)?_c('q-checkbox',{staticStyle:{"margin-top":"-40px"},attrs:{"color":"amber","checked-icon":"fas fa-fish","unchecked-icon":"fas fa-fish"},model:{value:(_vm.isSanma),callback:function ($$v) {_vm.isSanma=$$v},expression:"isSanma"}}):_vm._e(),_vm._v(" "),_c('TheScoreTable'),_vm._v(" "),_c('TheScoreSlider'),_vm._v(" "),_c('div',{staticClass:"col-6 add_row_btn"},[_c('q-btn',{staticClass:"full-width add_btn",attrs:{"outline":"","disable":_vm.loading,"color":"primary","label":"","icon":"fas fa-check","size":"1rem"},on:{"click":function($event){_vm.addRow()}}})],1),_vm._v(" "),_c('div',{staticStyle:{"padding-bottom":"60px"}},[_c('q-table',{staticClass:"total-points",attrs:{"data":_vm.totalPoints,"columns":_vm.columns,"row-key":"name","hide-header":"","hide-bottom":""}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_UserInfo_js__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_ScoreTable_js__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_TheScoreSlider_js__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_firebase__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_firebase__);






// import 'Firebase/firestore'

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var config = {
  apiKey: 'AIzaSyA0xmRYsdAzrbark3lZQZ8cj0gUp58WeF4',
  authDomain: 'mahjong-tensu.firebaseapp.com',
  databaseURL: 'https://mahjong-tensu.firebaseio.com',
  projectId: 'mahjong-tensu',
  storageBucket: 'mahjong-tensu.appspot.com',
  messagingSenderId: '336285987279'
};
var firebaseApp = __WEBPACK_IMPORTED_MODULE_5_firebase___default.a.initializeApp(config);
var firestore = firebaseApp.firestore();

firestore.settings({ timestampsInSnapshots: true });
var state = {
  db: __WEBPACK_IMPORTED_MODULE_5_firebase___default.a.firestore()
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: state,
  modules: {
    ScoreTable: __WEBPACK_IMPORTED_MODULE_3__modules_ScoreTable_js__["a" /* default */],
    TheScoreSlider: __WEBPACK_IMPORTED_MODULE_4__modules_TheScoreSlider_js__["a" /* default */],
    UserInfo: __WEBPACK_IMPORTED_MODULE_2__modules_UserInfo_js__["a" /* default */]
  }
}));

/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
  myScoreID: '',
  myUID: '',
  myDisplayName: '',
  shareScoreID: ''
};

var getters = {
  getMyScoreID: function getMyScoreID(state, getters, rootState) {
    return state.myScoreID;
  },
  getMyUID: function getMyUID(state, getters, rootState) {
    return state.myUID;
  },
  getMyDisplayName: function getMyDisplayName(state, getters, rootState) {
    return state.myDisplayName;
  },
  getShareScoreID: function getShareScoreID(state, getters, rootState) {
    return state.shareScoreID;
  }
};

var mutations = {
  setMyScoreID: function setMyScoreID(state, val) {
    state.myScoreID = val;
  },
  setMyUID: function setMyUID(state, val) {
    state.myUID = val;
  },
  setMyDisplayName: function setMyDisplayName(state, val) {
    state.myDisplayName = val;
  },
  setShareScoreID: function setShareScoreID(state, val) {
    state.shareScoreID = val;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  // actions,
  mutations: mutations
});

/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);



var state = {
  tableData: [{ player_1: 0, player_2: 0, player_3: 0, player_4: 0 }],
  columns: [{ name: 'player_1', required: true, label: 'A', align: 'center', field: 'player_1', uid: '' }, { name: 'player_2', required: true, label: 'B', align: 'center', field: 'player_2', uid: '' }, { name: 'player_3', required: true, label: 'C', align: 'center', field: 'player_3', uid: '' }, { name: 'player_4', required: true, label: 'D', align: 'center', field: 'player_4', uid: '' }],
  currentPageNum: 1,
  loading: true,
  isSanma: false,
  unsubscribeF: ''
};
var mutations = {
  changeLastRow: function changeLastRow(state, payload) {
    state.tableData[state.tableData.length - 1][payload.player] = payload.val;
  },
  changeCell: function changeCell(state, payload) {
    state.tableData[payload.targetIndex][payload.player] = payload.val;
  },
  incrementLastRowCell: function incrementLastRowCell(state, payload) {
    state.tableData[state.tableData.length - 1][payload.player]++;
  },
  decrementLastRowCell: function decrementLastRowCell(state, payload) {
    state.tableData[state.tableData.length - 1][payload.player]--;
  },
  changeCurrentPageNum: function changeCurrentPageNum(state, val) {
    state.currentPageNum = val;
  },
  incrementCurrentPageNum: function incrementCurrentPageNum(state, payload) {
    state.currentPageNum++;
  },
  changeLoading: function changeLoading(state, val) {
    state.loading = val;
  },
  setTableData: function setTableData(state, val) {
    state.tableData = val;
  },
  setColumnLabel: function setColumnLabel(state, payload) {
    state.columns[payload.num].label = payload.val;
  },
  setColumnUID: function setColumnUID(state, payload) {
    state.columns[payload.num].uid = payload.val;
  },
  addScoreRow: function addScoreRow(state) {
    var tmp = {};
    for (var key in state.columns) {
      tmp[state.columns[key].name] = 0;
    }
    state.tableData.push(tmp);
  },
  changeIsSanma: function changeIsSanma(state, val) {
    state.isSanma = val;
  },
  toSanma: function toSanma(state, val) {
    state.columns = [{ name: 'player_1', required: true, label: 'A', align: 'center', field: 'player_1', uid: '' }, { name: 'player_2', required: true, label: 'B', align: 'center', field: 'player_2', uid: '' }, { name: 'player_3', required: true, label: 'C', align: 'center', field: 'player_3', uid: '' }];
    state.tableData = [{ player_1: 0, player_2: 0, player_3: 0 }];
  },
  toYonma: function toYonma(state, val) {
    state.columns = [{ name: 'player_1', required: true, label: 'A', align: 'center', field: 'player_1', uid: '' }, { name: 'player_2', required: true, label: 'B', align: 'center', field: 'player_2', uid: '' }, { name: 'player_3', required: true, label: 'C', align: 'center', field: 'player_3', uid: '' }, { name: 'player_4', required: true, label: 'D', align: 'center', field: 'player_4', uid: '' }];
    state.tableData = [{ player_1: 0, player_2: 0, player_3: 0, player_4: 0 }];
  },
  setUnsubscribeF: function setUnsubscribeF(state, val) {
    state.unsubscribeF = val;
  }
};
var actions = {
  setDataFromScoreID: function setDataFromScoreID(_ref, scoreID) {
    var _this = this;

    var dispatch = _ref.dispatch,
        commit = _ref.commit,
        state = _ref.state,
        rootState = _ref.rootState;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var doc, cnt, key;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return rootState.db.collection('Scores').doc(scoreID).get();

            case 2:
              doc = _context.sent;

              if (!doc.exists) {
                _context.next = 17;
                break;
              }

              if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(doc.data().member).length === 3) {
                commit('changeIsSanma', true);
                commit('toSanma');
              } else {
                commit('changeIsSanma', false);
                commit('toYonma');
              }
              commit('setTableData', doc.data().score);
              cnt = 0;
              _context.t0 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.keys(doc.data().member);

            case 8:
              if ((_context.t1 = _context.t0()).done) {
                _context.next = 17;
                break;
              }

              key = _context.t1.value;

              if (!(key === '__index')) {
                _context.next = 12;
                break;
              }

              return _context.abrupt('continue', 8);

            case 12:
              commit('setColumnLabel', { num: cnt, val: doc.data().member[key].name });
              commit('setColumnUID', { num: cnt, val: doc.data().member[key].uid });
              ++cnt;
              _context.next = 8;
              break;

            case 17:
              // for real time update
              dispatch('listenDataFromScoreDB', scoreID);

            case 18:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  // for real time update
  listenDataFromScoreDB: function listenDataFromScoreDB(_ref2, scoreID) {
    var commit = _ref2.commit,
        state = _ref2.state,
        rootState = _ref2.rootState;

    var unsub = rootState.db.collection('Scores').doc(scoreID).onSnapshot(function (doc) {
      commit('setTableData', doc.data().score);
      var cnt = 0;
      for (var key in doc.data().member) {
        if (key === '__index') {
          continue;
        }
        commit('setColumnLabel', { num: cnt, val: doc.data().member[key].name });
        commit('setColumnUID', { num: cnt, val: doc.data().member[key].uid });
        ++cnt;
      }
    });
    // for stop listen
    commit('setUnsubscribeF', unsub);
  },
  unsubscribeListenData: function unsubscribeListenData(_ref3) {
    var commit = _ref3.commit,
        state = _ref3.state,
        rootState = _ref3.rootState;

    state.unsubscribeF();
  },
  reset: function reset(_ref4) {
    var commit = _ref4.commit,
        state = _ref4.state,
        rootState = _ref4.rootState;

    var initTableMember = ['A', 'B', 'C', 'D'];
    var key = 0;
    for (key in state.columns) {
      commit('setColumnLabel', { num: key, val: initTableMember[key] });
      commit('setColumnUID', { num: key, val: '' });
    }
    var tableData = [{}];
    if (state.columns.length === 4) {
      tableData = [{ player_1: 0, player_2: 0, player_3: 0, player_4: 0 }];
    } else {
      tableData = [{ player_1: 0, player_2: 0, player_3: 0 }];
    }
    commit('setTableData', tableData);
  },
  makeNewScoreDB: function makeNewScoreDB(_ref5, payload) {
    var _this2 = this;

    var commit = _ref5.commit,
        state = _ref5.state,
        rootState = _ref5.rootState;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var docRef;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return rootState.db.collection('Scores').add({
                score: payload.tableData,
                timestamp: payload.timestamp
              });

            case 2:
              docRef = _context2.sent;
              return _context2.abrupt('return', docRef.id);

            case 4:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  setScoreMemberToUserDB: function setScoreMemberToUserDB(_ref6, payload) {
    var _this3 = this;

    var commit = _ref6.commit,
        state = _ref6.state,
        rootState = _ref6.rootState;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var columns, member, key;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              columns = state.columns;
              member = {};

              for (key in columns) {
                member[columns[key].name] = { name: columns[key].label };
              }
              rootState.db.collection('Users').doc(payload.uid).collection('ScoreHistory').doc(payload.scoreID).set({
                scoreID: payload.scoreID,
                member: member,
                timestamp: payload.timestamp
              });

            case 4:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  setScoreIDToUserDB: function setScoreIDToUserDB(_ref7, payload) {
    var _this4 = this;

    var commit = _ref7.commit,
        state = _ref7.state,
        rootState = _ref7.rootState;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              rootState.db.collection('Users').doc(payload.uid).collection('ScoreHistory').doc(payload.scoreID).set({
                scoreID: payload.scoreID,
                timestamp: payload.timestamp
              }, { merge: true });

            case 1:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  },
  updateScoreMemberOfUserDB: function updateScoreMemberOfUserDB(_ref8, payload) {
    var commit = _ref8.commit,
        state = _ref8.state,
        rootState = _ref8.rootState;

    var columns = state.columns;
    var member = {};
    for (var key in columns) {
      member[columns[key].name] = { name: columns[key].label };
    }
    rootState.db.collection('Users').doc(payload.uid).collection('ScoreHistory').doc(payload.scoreID).update({
      member: member,
      timestamp: payload.timestamp
    });
  },
  updateDBScoreMember: function updateDBScoreMember(_ref9, payload) {
    var _this5 = this;

    var commit = _ref9.commit,
        state = _ref9.state,
        rootState = _ref9.rootState;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
      var columns, member, key;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              columns = state.columns;
              member = {};

              for (key in columns) {
                member[columns[key].name] = { name: columns[key].label, uid: columns[key].uid };
              }
              rootState.db.collection('Scores').doc(payload.scoreID).update({
                member: member
              });

            case 4:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  },
  updateScoreDB: function updateScoreDB(_ref10, payload) {
    var commit = _ref10.commit,
        state = _ref10.state,
        rootState = _ref10.rootState;

    // use my score id after first time
    rootState.db.collection('Scores').doc(payload.scoreID).update({
      score: payload.tableData,
      timestamp: payload.timestamp
    });
  }
};
var getters = {
  getTableData: function getTableData(state, getters, rootState) {
    return state.tableData;
  },
  getColumns: function getColumns(state, getters, rootState) {
    return state.columns;
  },
  getLastRow: function getLastRow(state, getters, rootState) {
    return state.tableData[state.tableData.length - 1];
  },

  getLastRowPlayerVal: function getLastRowPlayerVal(state) {
    return function (player) {
      return state.tableData[state.tableData.length - 1][player];
    };
  },
  getCurrentPageNum: function getCurrentPageNum(state, getters, rootState) {
    return state.currentPageNum;
  },
  getLoading: function getLoading(state, getters, rootState) {
    return state.loading;
  },
  getIsSanma: function getIsSanma(state, getters, rootState) {
    return state.isSanma;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
  sliders: [{ player: 'player_1', color: 'deep-purple-2' }, { player: 'player_2', color: 'teal-2' }, { player: 'player_3', color: 'pink-2' }, { player: 'player_4', color: 'deep-orange-2' }]
};
var mutations = {
  toSanma: function toSanma(state, val) {
    state.sliders = [{ player: 'player_1', color: 'deep-purple-2' }, { player: 'player_2', color: 'teal-2' }, { player: 'player_3', color: 'pink-2' }];
  },
  toYonma: function toYonma(state, val) {
    state.sliders = [{ player: 'player_1', color: 'deep-purple-2' }, { player: 'player_2', color: 'teal-2' }, { player: 'player_3', color: 'pink-2' }, { player: 'player_4', color: 'deep-orange-2' }];
  }
};
var actions = {
  buttonAction: function buttonAction(_ref) {
    var commit = _ref.commit,
        state = _ref.state,
        rootState = _ref.rootState;

    console.log('buttonAction');
  }
};
var getters = {
  getSliders: function getSliders(state, getters, rootState) {
    return state.sliders;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 145 */,
/* 146 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 147 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 148 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 149 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 150 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
]),[59]);


// WEBPACK FOOTER //
// static/js/app.017a17fcc6ec069aba10.js